// Change ELIGIBILITY_INSTITUTE_ID before deploying to production
export const ELIGIBILITY_INSTITUTE_ID = '7c0bea40-58f1-4dd8-b94f-753da3411e97';
export const ELIGIBILITY_ROLES = ['institute_user', 'institute_admin'];
export const TEST_INSTITUTE_ID = '076e0211-7e3f-44cb-87f6-252c09f49a1d';
